exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.oneschema-iframe {\n  width: 100vw;\n  height: 90vh;\n  border: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1000;\n  padding-bottom: 5rem;\n}\n.full-height {\n  height: calc(100vh - 5rem) !important;\n  padding-bottom: 5rem !important;\n}\n", ""]);

// exports
